import React, { useState, useEffect } from 'react';
import { settingsAPI } from '../../utils/api';
import { toast } from 'react-toastify';

// Settings kommen als { value, description } oder als blanker Wert zurueck
const readSetting = (settings, key) => {
  const entry = settings ? settings[key] : null;
  if (!entry) return '';
  return (typeof entry === 'object' ? entry.value : entry) || '';
};

const EmailSetting = ({ title, description, settingKey, placeholder, settings, loadSettings, hint }) => {
  const [value, setValue] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setValue(readSetting(settings, settingKey));
  }, [settings, settingKey]);

  const handleSave = async () => {
    if (!value.trim()) {
      toast.error('Bitte E-Mail-Adresse eingeben');
      return;
    }
    try {
      setSaving(true);
      const response = await settingsAPI.updateSetting(settingKey, value.trim());
      if (response.success) {
        toast.success(`${title} wurde gespeichert`);
        setIsEditing(false);
        await loadSettings();
      }
    } catch (error) {
      console.error('Fehler beim Speichern:', error);
      toast.error('Fehler beim Speichern der E-Mail');
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    setValue(readSetting(settings, settingKey));
    setIsEditing(false);
  };

  return (
    <div style={{background: '#f8f9fa', padding: '24px', borderRadius: '8px', maxWidth: '640px', marginBottom: '20px'}}>
      <h4 style={{marginBottom: '8px'}}>📧 {title}</h4>
      <p style={{color: '#666', fontSize: '0.9em', marginBottom: '15px'}}>{description}</p>

      {isEditing ? (
        <div style={{display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap'}}>
          <input
            type="email"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={placeholder}
            style={{flex: '1 1 240px', padding: '10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px'}}
            autoFocus
          />
          <button onClick={handleSave} className="btn btn-success" disabled={saving}>
            {saving ? 'Speichere...' : '✅ Speichern'}
          </button>
          <button onClick={handleCancel} className="btn btn-secondary" disabled={saving}>
            Abbrechen
          </button>
        </div>
      ) : (
        <div style={{display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap'}}>
          <div style={{
            flex: '1 1 240px', padding: '10px', background: 'white', border: '1px solid #ddd',
            borderRadius: '4px', minHeight: '40px', display: 'flex', alignItems: 'center'
          }}>
            {value ? <span>{value}</span> : <span style={{color: '#999', fontStyle: 'italic'}}>{hint}</span>}
          </div>
          <button onClick={() => setIsEditing(true)} className="btn btn-primary">
            ✏️ Bearbeiten
          </button>
        </div>
      )}
    </div>
  );
};

const SettingsTab = ({ settings, loadSettings }) => {
  return (
    <div className="settings-section">
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
        <h3>E-Mail Einstellungen</h3>
      </div>

      <EmailSetting
        title="Spielanmeldungen"
        description="An diese Adresse gehen Benachrichtigungen über neue Anmeldungen zu Spielen."
        settingKey="admin_email"
        placeholder="vorstand@efc-buseck.de"
        hint="Noch keine E-Mail konfiguriert"
        settings={settings}
        loadSettings={loadSettings}
      />

      <EmailSetting
        title="Klamotten-Bestellungen"
        description="An diese Adresse gehen Benachrichtigungen über neue Bestellungen bei den Klamotten. Bleibt das Feld leer, werden sie an die Adresse für Spielanmeldungen geschickt."
        settingKey="shop_email"
        placeholder="shop@efc-buseck.de"
        hint="Nicht gesetzt – Bestellungen gehen an die Adresse für Spielanmeldungen"
        settings={settings}
        loadSettings={loadSettings}
      />
    </div>
  );
};

export default SettingsTab;
